import { render, staticRenderFns } from "./PortalAddShops.vue?vue&type=template&id=362ffb8a&scoped=true&"
import script from "./PortalAddShops.vue?vue&type=script&lang=js&"
export * from "./PortalAddShops.vue?vue&type=script&lang=js&"
import style0 from "./PortalAddShops.vue?vue&type=style&index=0&id=362ffb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ffb8a",
  null
  
)

export default component.exports